// TrackIP.js or inside useEffect in your Analytics page
import { useEffect } from 'react';
import axiosOuter from 'axios';

import axios from '../api/axios';

const TrackIP = () => {
  useEffect(() => {
    const trackIP = async () => {
      try {
        const ipResponse = await axiosOuter.get('https://api.ipify.org?format=json');
        const userIP = ipResponse.data.ip;

        // Send to backend
       /*  await axios.post('/api/track-ip', {
          ip_address: userIP,
        });
 */




        const config = {
           
        };
    
        const bodyParameters = {
            ip_address: userIP
        };
        axios
            //  .get("/api/v1/get-profile", {},{ headers: {"Authorization" : `Bearer ${token}`} })
            .post("/track-ip", bodyParameters, config)
            .then((res) => {
                console.log('res.result');
                console.log(res.data.result);
            
             //   setLoader(false);
            })
            .catch((err) => {
             //   setLoader(false);
            });





      } catch (error) {
        console.error('IP tracking failed', error);
      }
    };

    trackIP();
  }, []);

  return null;
};

export default TrackIP;
